/* eslint-env browser */
/* eslint no-undef: "GIG" */

'use strict';

const { h, Component } = require('phy');

const notificationComponent = require('../components/notification_component');

class NotificationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fadeNode: false,
    };
    this.timeout = null;
  }

  componentDidMount() {
    // if GIG isn't loaded yet
    try {
      GIG.Alerts.init('.promo-code-v2');
    } catch (e) {}
    this.timeout = setTimeout(() => {
      // if user already closed don't try to close
      if (document.querySelector('.promo-code-v2 .notification')) {
        this.setState({ fadeNode: true });
      }
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    return h(notificationComponent, {
      ...this.props,
      ...this.state,
    });
  }
}

module.exports = NotificationContainer;
